module.exports = __webpack_public_path__ + "static/media/logo_full.0bb66b88.svg";